import { withAsyncBoundary } from '@toss/async-boundary';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { useSingularSubscriptionPaymentResult } from '../../../../services';
import { BusinessPaymentLayout } from '../../business/BusinessPaymentLayout';
import { BusinessPaymentInvalidPage } from '../../business/BusinessPayments';
import S from '../../business/BusinessPayments.module.scss';
const SingularPaymentsFailInner = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['business']);
  const paymentRequestHashId = (router.query.id ?? '').toString();
  const email = (router.query.email ?? '').toString();
  const {
    data: paymentInformation,
    isFetched
  } = useSingularSubscriptionPaymentResult({
    paymentRequestHashId,
    email
  });
  if (!isFetched) {
    return <></>;
  }
  return <BusinessPaymentLayout
  // @ts-ignore
  title={paymentInformation?.paymentRequest.customerName} data-sentry-element="BusinessPaymentLayout" data-sentry-component="SingularPaymentsFailInner" data-sentry-source-file="SingularPaymentsFail.tsx">
      <div className={S.payments_result_section}>
        <h2 className={S.payments_result_title}>
          {t('business:business_payments_failure')}
        </h2>
        <div>
          {t('business:business_payments_failure_content1', {
          name: paymentInformation?.paymentRequest.customerName
        })}
        </div>
        <div>{t('business:business_payments_failure_content2')}</div>
      </div>
      <Button className={S.retry_button} size="lg" onClick={() => router.replace(`/payment/singular/${paymentRequestHashId}`)} data-sentry-element="Button" data-sentry-source-file="SingularPaymentsFail.tsx">
        {t('business:business_payments_retry_button')}
      </Button>
    </BusinessPaymentLayout>;
};
export const SingularPaymentsFail = withAsyncBoundary(SingularPaymentsFailInner, {
  pendingFallback: '',
  rejectedFallback: () => <BusinessPaymentInvalidPage />
});